import { Link } from "gatsby";
import styled from "styled-components";
import closeIcon from "../../resources/images/close-icon.svg";

export const StyledOverlay = styled.div`
  height: 100%;
  width: ${(props) => (props.overlay ? "100%" : "0")};
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background: #ffffff;
  overflow-x: hidden;
  transition: 0.5s;
`;
export const StyledOverlayContent = styled.div`
  position: relative;
  width: 100%;
  min-height: 100%;
  text-align: center;
  display: grid;
  grid-row-gap: 112px;
`;

export const StyledCloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 45px;
  background-image: url(${closeIcon});
  width: 40px;
  height: 40px;
  background-color: white;
  border: none;
  background-size: 50% 50%;
  z-index: 1020;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 50%;
  cursor: pointer;
  outline: none;
`;

export const StyledBurgerContainer = styled.div`
  cursor: pointer;
  width: 30px;
  height: 30px;
  position: relative;
  align-items: center;
  justify-items: center;
  display: none;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  @media (max-width: 1020px) {
    display: grid;
  }
`;

export const StyledTextButton = styled.a`
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  transition: 0.3s;
  :hover {
    color: #1e67d3;
  }
`;

export const StyledBlogLink = styled(Link)`
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #264445;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  transition: 0.3s;
  z-index: 1020;
  :hover {
    color: #1e67d3;
  }
`;

export const StyledTopContainer = styled.div`
  display: grid;
  grid-row-gap: 40px;
  margin-top: 140px;
`;
export const StyledBottomContainer = styled.div`
  display: grid;
  grid-row-gap: 27px;
`;

export const StyledButton = styled.div`
  z-index: 2020;
  padding-bottom: 50px;
  button {
    width: 146px;
    height: 56px;
  }
`;

export const StyledBottomImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 500px;
`;

export const StyledTopImage = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  height: 500px;
`;
